import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HowMuchInsuraceLogicService {

  constructor() { }
  inflationFactor = 0.03;
  
  
  
  
  
  data;
  currentSaving;
  otherInvestments;
  existLyfCoverage;
  currentIncomeAfterTaxes;
  percentIncomUrFmlyNeed;
  hwLngFamlyNeedFinSuport;
  amtMortgage;
  otherLoansNdDeb;
  other;
  setData(howMuchData) {
    this.data = howMuchData;
  }
  doCalc() {
    this.assignVariables();
    const x = (this.currentSaving + this.otherInvestments + this.existLyfCoverage);
    const y = (this.amtMortgage + this.otherLoansNdDeb + this.other);
    const z = (x - y);
    const alpha = (this.currentIncomeAfterTaxes * (this.percentIncomUrFmlyNeed / 100));
    const beta = (Math.pow((1 + this.inflationFactor), this.hwLngFamlyNeedFinSuport));
    const delta = (alpha * ((beta - 1) / this.inflationFactor));
    const needed = (z - delta);
    if (needed >= 0) {
      return 0;
    } else if (needed < 0) {
      const result = Math.round((needed * 10) / 10);

      return result;
    }
  }
  assignVariables() {
    this.currentSaving = this.data.currentSaving;
    this.otherInvestments = this.data.otherInvestments;
    this.existLyfCoverage = this.data.existLyfCoverage;
    this.currentIncomeAfterTaxes = this.data.currentIncomeAfterTaxes;
    this.percentIncomUrFmlyNeed = this.data.percentIncomUrFmlyNeed;
    this.hwLngFamlyNeedFinSuport = this.data.hwLngFamlyNeedFinSuport;
    this.amtMortgage = this.data.amtMortgage;
    this.otherLoansNdDeb = this.data.otherLoansNdDeb;
    this.other = this.data.other;
  }
}
